import { render, staticRenderFns } from "./BillingView.vue?vue&type=template&id=8f3c57a4&lang=pug"
import script from "./BillingView.vue?vue&type=script&lang=ts"
export * from "./BillingView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8f3c57a4')) {
      api.createRecord('8f3c57a4', component.options)
    } else {
      api.reload('8f3c57a4', component.options)
    }
    module.hot.accept("./BillingView.vue?vue&type=template&id=8f3c57a4&lang=pug", function () {
      api.rerender('8f3c57a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/billing/Billing/BillingView.vue"
export default component.exports